import React from 'react';
import {MenuItem, TextField} from '@mui/material';
import {dashboardMetrics} from './dashboardMetrics';
import {dashboardMetricInputStyles, dashboardMetricMenuProps} from './DashboardControls';

export default function MetricSelect({value, onChange, label = 'Metric'}) {
    return (
        <TextField select size="small" label={label} value={value}
                   onChange={event => onChange(event.target.value)}
                   slotProps={{select: {MenuProps: dashboardMetricMenuProps}, inputLabel: {shrink: true}}}
                   sx={dashboardMetricInputStyles}>
            {dashboardMetrics.map(metric => <MenuItem key={metric.key} value={metric.key}>{metric.label}</MenuItem>)}
        </TextField>
    );
}
